module.exports = __webpack_public_path__ + "static/media/Dr. Evan McMullin - 2016.b4c4e63e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Dr. Evan McMullin - 2016.jpg
// module id = 456
// module chunks = 0